var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgFacebookLogo = function SvgFacebookLogo(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 25 25"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#FacebookLogo_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#0076A8",
    d: "M12.793 0C6.153 0 .77 5.383.77 12.022c0 5.638 3.881 10.37 9.118 11.668v-7.994h-2.48v-3.674h2.48V10.44c0-4.092 1.852-5.988 5.87-5.988.76 0 2.075.15 2.613.298v3.33c-.284-.03-.777-.044-1.39-.044-1.97 0-2.732.746-2.732 2.688v1.3h3.927l-.675 3.673H14.25v8.26c5.953-.719 10.566-5.787 10.566-11.934C24.816 5.382 19.433 0 12.793 0"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "FacebookLogo_svg__a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M.77 0h24.045v24.044H.77z"
  })))));
};
export default SvgFacebookLogo;